import { Component, OnInit, Inject, LOCALE_ID, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Frequency } from '../frequency';
import { FREQUENCIES } from '../frequency-list';
import { SchoolInfoService } from '../school-info.service';
import { LocaleService } from '../locale.service';
import { frenchSelectValidator } from '../validator/french-select-validator';
import { examDateValidator } from '../validator/exam-date-validator';
import { friendNameValidator } from '../validator/friend-name-validator';
import { MedicalInfoService } from '../medical-info.service';
import { Booking } from '../booking';
import { englishSelectValidator } from '../validator/english-select-validator';
import { dutchSelectValidator } from '../validator/dutch-select-validator';

@Component({
  selector: 'app-school-info',
  templateUrl: './school-info.component.html',
  styleUrls: ['./school-info.component.css']
})
export class SchoolInfoComponent implements OnInit {

  schoolForm!: FormGroup;
  frequencies: Frequency[] = FREQUENCIES;

  locale: any;
  hasError: boolean = false;

  @Input()
  booking!: Booking;

  @Input()
  submitFail!: boolean;


  constructor(
    public schoolInfoService: SchoolInfoService,
    private localService: LocaleService,
    @Inject(LOCALE_ID)
    private localeId: string,
    private builder: FormBuilder,
    public medicalInfoService: MedicalInfoService
  ) { }

  ngOnInit() {
    this.locale = this.localService.setCalendarLanguage(this.localeId);
    this.schoolInfoService.schoolForm = this.builder.group({
      studyDutchInSchool: [null, Validators.required],
      studyEnglishInSchool: [null, Validators.required],
      studyFrenchInSchool: [null, Validators.required],
      dutchStudyYears: [null],
      englishStudyYears: [null],
      frenchStudyYears: [null],
      dutchStudyHours: [null],
      englishStudyHours: [null],
      frenchStudyHours: [null],
      frequencySpeakingWithFamily: [null, Validators.required],
      frequencySpeakingWithFriends: [null, Validators.required],
      hasLearningDifficulty: [null, Validators.required],
      hadLanguageTest: [null, Validators.required],
      languageTestDate: [null],
      matterToReview: [""],
      studyBookName: [""],
      dutchTeacherName: [""],
      englishTeacherName: [""],
      frenchTeacherName: [""],
      isComingWithFriends: [null, Validators.required],
      friendName: [""]
    },
    {
      validator: [
        dutchSelectValidator, 
        englishSelectValidator, 
        frenchSelectValidator, 
        examDateValidator, 
        friendNameValidator
      ]
    }
    );
  }

}
